import {View} from "vritra";
import NativeIcon from "../../../NativeIcon";


const SideBarNavigatorEntryProps=[
    {
        name:"id",
        type:"string",
        required:true,
    },
    {
        name:"name",
        type:"string",
        description:"if no name is supplied, the id is used as a name",
    },
    NativeIcon,
    {
        name:"entries",
        type:"SideBarNavigatorEntry[]",
        description:"If undefined, the entry is an endpoint else a folder",
    },
    {
        name:"renderContent",
        type:"(container:HTMLElement):HTMLElement",
        description:"Only for endpoint entries",
        props:[
            {
                name:"container",
                type:"HTMLElement",
                description:"Content container",
            }
        ],
    },
    {
        name:"memorize",
        type:"boolean",
        description:"If true, the content element returned by renderContent is used for next renders, default to true",
    },
    {
        name:"expanded",
        type:"boolean",
        description:`
            For folder entries only
            @Parent-folders are automatically expanded
            @default false
        `,
    },
]

export default {
    id:"SideBarNavigator",
    parent:{name:"View"},
    preview:(props)=>{
        const view=View(props);
        view.innateHTML=`
            <p style="font-size:5em;color:${textColor};">It's this component you're using to navigate right now</p>
        `;
        return view;
    },
    props:[
        ...["sidebarClassName","containerClassName"].map(name=>({name,type:"string"})),
        {
            name:"entries",
            type:"SideBarNavigatorEntry[]",
            props:[
                {
                    name:"SideBarNavigatorEntry",
                    type:"object",
                    props:SideBarNavigatorEntryProps,
                }
            ],
        },
        {
            name:"tintColor",
            type:"string",
            description:"Endpoint color when active,default to dodgerblue",
        },
        {
            name:"folderColor",
            type:"string",
            description:"default to black",
        },
        {
            name:"endpointColor",
            type:"string",
            description:"default to rgba(0,0,0,0.35)",
        },
        {
            name:"sideBarScrollTheme",
            type:`"drak"|"light"`,
            description:"default to dark",
        },
        {
            name:"onNavigate",
            type:"(current:Object,previous:Object|null):void",
            props:[
                {
                    name:"current",
                    type:"{id:String,name:String}",
                    description:"currently shown entry id",
                },
                {
                    name:"previous",
                    type:"{id:String,name:String}|null",
                    description:"previously shown entry id",
                },
            ],
        },
    ],
    methods:[
        {
            name:"navigate",
            type:"(entryId:string,triggerOnNavigate?:boolean):void",
            props:[
                {
                    name:"triggerOnNavigate",
                    type:"boolean",
                    description:"default to true",
                },
            ],
        },
        {
            name:"getCurrentEntry",
            type:"():{id:String,name:String}|null",
        },
        {
            name:"toggleSideBar",
            type:"(shown?:boolean):void",
            props:[{
                name:"shown",
                type:"boolean",
                description:"default: toggling behavior",
            }],
        },
    ],
}
